// https://github.com/styled-components/styled-components/blob/master/packages/styled-components/docs/tips-and-tricks.md#more-powerful-example

//github.com/morajabi/styled-media-query/blob/master/src/index.d.ts

import { css, DefaultTheme, ThemedCssFunction } from 'styled-components';

import { theme } from './theme';

const {
  siteMaxWidth,
  ipadProHorizontal,
  large,
  ipadHorizontal,
  ipadVertical,
  iphoneVertical,
} = theme.breakpoints;

type ThemedCssFunctionArgs = Parameters<ThemedCssFunction<DefaultTheme>>;
const mediaFactory =
  (queryFeatures: string) =>
  (...args: ThemedCssFunctionArgs) =>
    css`
      @media ${queryFeatures} {
        ${css(...args)};
      }
    `;

export const media = {
  greaterThanMaxSize: mediaFactory(`(min-width: ${siteMaxWidth + 1}px)`),
  // iPad Pro Horizontal
  greaterThanIpadProHorizontal: mediaFactory(
    `(min-width: ${ipadProHorizontal + 1}px)`
  ),
  ipadProHorizontalOrMore: mediaFactory(`(min-width: ${ipadProHorizontal}px)`),
  ipadProHorizontalOrLess: mediaFactory(`(max-width: ${ipadProHorizontal}px)`),
  lessThanIpadProHorizontal: mediaFactory(
    `(max-width: ${ipadProHorizontal - 1}px)`
  ),
  greaterThanLarge: mediaFactory(`(min-width: ${large + 1}px)`),
  largeOrMore: mediaFactory(`(min-width: ${large}px)`),
  largeOrLess: mediaFactory(`(max-width: ${large}px)`),
  lessThanlarge: mediaFactory(`(max-width: ${large - 1}px)`),
  //  iPad Horizontal
  greaterThanIpadHorizontal: mediaFactory(
    `(min-width: ${ipadHorizontal + 1}px)`
  ),
  ipadHorizontalOrMore: mediaFactory(`(min-width: ${ipadHorizontal}px)`),
  ipadHorizontalOrLess: mediaFactory(`(max-width: ${ipadHorizontal}px)`),
  lessThanIpadHorizontal: mediaFactory(`(max-width: ${ipadHorizontal - 1}px)`),
  // iPad Vertical
  greaterThanIpadVertical: mediaFactory(`(min-width: ${ipadVertical + 1}px)`),
  ipadVerticalOrMore: mediaFactory(`(min-width: ${ipadVertical}px)`),
  ipadVerticalOrLess: mediaFactory(`(max-width: ${ipadVertical}px)`),
  lessThanIpadVertical: mediaFactory(`(max-width: ${ipadVertical - 1}px)`),
  lessThanIpadVerticalLandscape: mediaFactory(
    `(max-width: ${ipadVertical - 1}px) and (orientation: landscape)`
  ),
  // iPhone Vertical
  greaterThanIphoneVertical: mediaFactory(
    `(min-width: ${iphoneVertical + 1}px)`
  ),
  iphoneVerticalOrMore: mediaFactory(`(min-width: ${iphoneVertical}px)`),
  iphoneVerticalOrLess: mediaFactory(`(max-width: ${iphoneVertical}px)`),
  lessThanIphoneVertical: mediaFactory(`(max-width: ${iphoneVertical - 1}px)`),
};
